import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import { graphql, StaticQuery } from 'gatsby'
import _ from 'lodash'
import * as styles from './styles'
import { Section } from '..'
import fixMissingData from '../../../assets/fix-missing-data-color.svg'
import leadQualification from '../../../assets/lead-qualification-color.svg'
import orderHandlingAutomation from '../../../assets/order-handling-automation-color.svg'

const propTypes = {
  data: PropTypes.object.isRequired
}

const AitoShowcases = ({ data }) => {
  const showcaseImages = [fixMissingData, leadQualification, orderHandlingAutomation]
  return (
    <styles.Container>
      <styles.SubContainer>
        <Row>
          <Col xs={12}>
            <styles.AitoShowcasesHeader>
              {data.header}
            </styles.AitoShowcasesHeader>
          </Col>
        </Row>
        <Section>
          <Row>
            {_.map(data.showcases, (item, i) => {
              return (
                <styles.ShowcaseCol sm={4} xs={12} key={i}>
                  <styles.StyledLink to={item.url}>
                    <styles.ShowcaseCard>
                      <styles.ImgContainer>
                        <styles.ImgPlaceholder src={showcaseImages[i]} alt="use case" />
                      </styles.ImgContainer>
                      <styles.CardTextContainer>
                        <styles.ShowcaseHeader>
                          {item.header}
                        </styles.ShowcaseHeader>
                        <styles.ShowcaseText>
                          {item.text}
                        </styles.ShowcaseText>
                        <styles.LearnMore>
                          <div className="learn-more">
                            Learn more
                            <styles.Chevron />
                          </div>
                        </styles.LearnMore>
                      </styles.CardTextContainer>
                    </styles.ShowcaseCard>
                  </styles.StyledLink>
                </styles.ShowcaseCol>
              )
            })}
          </Row>
        </Section>
      </styles.SubContainer>
    </styles.Container>
  )
}

AitoShowcases.propTypes = propTypes

export default () => (
  <StaticQuery
    query={graphql`
      query GetAitoShowcases {
        allYaml(filter: {file: {eq: "aito-showcases"}}) {
          edges {
            node {
              header
              showcases {
                header
                text
                url
              }
            }
          }
        }
      }
    `
    }
    render={(data) => {
      const { allYaml } = data
      const { edges } = allYaml
      const { node } = _.first(edges)
      return (
        <AitoShowcases data={node} />
      )
    }}
  />
)
